import { gql } from 'src/generated/gql';

export const REFRESH_SCHEDULE_MUTATION = gql(`
  mutation StaffRefreshSchedule {
    staff_refreshSchedule
  }
`);
